export enum RouteLocationType {
  ORIGIN = 'ORIGIN',
  VIA = 'VIA',
  DESTINATION = 'DESTINATION',
}
